export default "__VITE_ASSET__lO6JQX5A__"